



















































































































































































































































































































































































































































































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import {
  ExpantionState,
  TaskDetail,
  DefaultLeftAttributes,
  TaskAttribute,
  AttributeName,
  DefaultRightAttributes,
  Representative,
  SelectTaskList,
  CustomAttribute,
  CustomTile,
  Tile,
  TaskDetailParam,
  TaskAttributeGroup,
} from '@/@types/LibraryComponent';
import CommentList from '@/components/taskList/taskDetailModal/CommentList.vue';
import CommentInput from '@/components/taskList/taskDetailModal/CommentInput.vue';
import DebugUserIcon from '@/components/common/DebugUserIcon.vue';
import EditableText from '@/components/common/EditableText.vue';
import EditableTextArea from '@/components/common/EditableTextArea.vue';
import EditableTextPerformance from '@/components/common/EditableTextPerformance.vue';
import EditableTextSchedule from '@/components/common/EditableTextSchedule.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import DatePickerMenu from '@/components/taskList/taskListTableParts/DatePickerMenu.vue';
import PersonMenu from '@/components/taskList/taskListTableParts/PersonMenu.vue';
import AddTaskList from '@/components/taskList/taskModalParts/AddTaskList.vue';
import { Task, ChildTask, TaskComment, MinimizedTask } from '@/@types/Task';
import { TaskAttributeValueOption } from '@/@types/Project';
import { vxm } from '@/store';
import dayjs from 'dayjs';
import SelectMenu from '@/components/taskList/taskListTableParts/SelectMenu.vue';
import AccentSelectMenu from '@/components/taskList/taskListTableParts/AccentSelectMenu.vue';
import { ActivityKindCd, ATTRIBUTE_STYLE, RoleCd } from '@/@types/constant';
import { CreateActivityDto } from '@/@types/activity';

@Component({
  components: {
    CommentList,
    DebugUserIcon,
    EditableText,
    EditableTextArea,
    EditableTextSchedule,
    EditableTextPerformance,
    CommentInput,
    CommonButton,
    DatePickerMenu,
    PersonMenu,
    AddTaskList,
    SelectMenu,
    AccentSelectMenu,
  },
})
export default class TaskDetailModal extends Vue {
  @Prop()
  private readonly representatives!: Representative[];
  @Prop()
  private readonly selectTaskList!: SelectTaskList[];
  @Prop()
  private readonly customAttributes!: CustomAttribute[];
  @Prop()
  private customTiles!: CustomTile[];
  @Prop()
  private priorities!: TaskAttributeGroup[];
  @Prop()
  private statuses!: TaskAttributeGroup[];
  @Prop()
  private categories!: TaskAttributeGroup[];
  private resetKey: number = 0;
  private CommonButtonColorRegistration: string = '#4384f3';
  /**
   * 子課題リストは0でオープン
   */
  private readonly EXPANTION_STATE: ExpantionState = { OPEN: 0, CLOSE: 1 };

  private isExpandChildTasks: number = this.EXPANTION_STATE.CLOSE;

  // スクロール移動の方向
  private scrollToDirection: string = 'down';

  // コメント入力中かどうか
  private isWriteComment: boolean = false;

  // タスクが
  private isTaskDetailModal: boolean = true;

  private commentContent: string = '';

  private accountId: number = 1;

  private createTaskCommentAttachmentFiles: (string | Blob)[] = [];

  private completedApprovalFlag: boolean = false;

  private COMPLETED_APPROVAL_CD = {
    select: {
      approved: '未承認に戻す',
      denied: '承認する',
    },
    display: {
      approved: '承認済み',
      denied: '未承認',
    },
  } as const;

  // HTMLElement 要素化どうかテストする関数
  private isHTMLElement = (x: any): x is HTMLElement =>
    x instanceof HTMLElement;

  /**
   * 左枠に表示するタスクの属性一覧を取得する
   */
  private filteredAttributes(
    taskDetail: TaskDetail,
    priority: boolean
  ): Array<{
    id: number;
    type: string;
    value: string;
    priority: boolean;
  }> {
    const attributes = taskDetail.attributes.filter(
      (attribute: {
        id: number;
        type: string;
        value: string;
        priority: boolean;
      }) => attribute.priority === priority
    );
    return attributes;
  }

  private async created() {
    if (!this.task) {
      throw new Error('task is undefined');
    }
    const query = { 'project-id': this.projectId };

    await vxm.theoryApi.tasksStore.fetchTaskComments({
      taskId: this.task.taskId,
      query: query,
    });
    const task = this.task;
    this.completedApprovalFlag = task.completedApprovalFlag;
  }

  /**
   * 子課題リストの開閉
   */
  private toggleChildTasks(): void {
    if (this.isExpandChildTasks === this.EXPANTION_STATE.OPEN) {
      this.isExpandChildTasks = this.EXPANTION_STATE.CLOSE;
    } else {
      this.isExpandChildTasks = this.EXPANTION_STATE.OPEN;
    }
  }

  /**
   * スクロール領域のスクロールイベントハンドラ
   */
  private scroll(e: Event): void {
    // 自動スクロールボタンの行き先の変更
    if (this.isHTMLElement(this.$refs.modalContent)) {
      const modalElement: HTMLElement = this.$refs.modalContent as HTMLElement;
      const scrollSize: number = 300;
      if (
        modalElement.scrollTop >= scrollSize &&
        this.scrollToDirection === 'down'
      ) {
        this.scrollToDirection = 'up';
      } else if (
        modalElement.scrollTop < scrollSize &&
        this.scrollToDirection === 'up'
      ) {
        this.scrollToDirection = 'down';
      } else return;
    }
  }

  private scrollToTopOrBottom(): void {
    const modalElement: HTMLElement = this.$refs.modalContent as HTMLElement;
    if (this.scrollToDirection === 'down') {
      modalElement.scroll({
        top: modalElement.scrollHeight,
        behavior: 'smooth',
      });
    } else if (this.scrollToDirection === 'up') {
      modalElement.scroll({ top: 10, behavior: 'smooth' });
    } else return;
  }

  /** 期限日と現在時刻の差異を算出 */
  private differenceOfDates(date: Date | null): string | null {
    if (date) {
      if (this.isDeadline(date)) {
        const limitDate = dayjs(date)
          .subtract(Number(dayjs().format('DD')), 'd')
          .format('D');
        return `あと${limitDate}日`;
      } else {
        const limitDate = dayjs()
          .subtract(Number(dayjs(date).format('DD')), 'd')
          .format('D');
        return `${limitDate}日遅れ`;
      }
    } else {
      return null;
    }
  }

  /** コメントの最終更新時刻と現在時刻との差異を算出 */
  private differenceOfTimes(): string | null {
    const time =
      this.taskComments.length > 0 ? this.taskComments[0].updatedAt : null;
    if (time) {
      const difference = new Date().getTime() - new Date(time).getTime();
      const elapsedTime = new Date(difference);
      if (elapsedTime.getUTCFullYear() - 1970) {
        return `最終更新:${elapsedTime.getUTCFullYear() - 1970}年前`;
      } else if (elapsedTime.getUTCMonth()) {
        return `最終更新:${elapsedTime.getUTCMonth()}ヶ月前`;
      } else if (elapsedTime.getUTCDate() - 1) {
        return `最終更新:${elapsedTime.getUTCDate() - 1}日前`;
      } else if (elapsedTime.getUTCHours()) {
        return `最終更新:${elapsedTime.getUTCHours()}時間前`;
      } else if (elapsedTime.getUTCMinutes()) {
        return `最終更新:${elapsedTime.getUTCMinutes()}分前`;
      } else {
        return `最終更新:たった今`;
      }
    } else return null;
  }

  /** 課題コメント登録 */
  private async createTaskComment() {
    if (this.task) {
      const taskId: number = this.task.taskId;
      const formData = new FormData();
      this.createTaskCommentAttachmentFiles.forEach((f) => {
        formData.append('attachmentFiles', f);
      });
      this.createTaskCommentAttachmentFiles.splice(0);
      formData.append('projectId', `${this.projectId}`);
      formData.append('accountId', `${this.accountId}`);
      formData.append('commentContent', `${this.commentContent}`);
      const query = { 'project-id': this.projectId };
      const createResult = await vxm.theoryApi.tasksStore.createTaskComment({
        taskId: taskId,
        param: formData,
        query: query});
      if (createResult) {
        const createActivitiesParam: CreateActivityDto = {
          activityKindCd: ActivityKindCd.addTaskComment,
          actionAccountId: this.accountId as number,
          projectId: this.projectId,
          projectName: this.project?.projectName as string,
          taskId: this.task.taskId,
          taskName: this.task.taskName,
          taskCommentId: createResult.results.taskCommentId,
          accountId: null,
          shiftId: null,
          messageId: null,
          branchId: null,
          pullrequestId: null,
          pullrequestCommentId: null,
          commentContent: createResult.results.commentContent,
          status: null,
        };
        await vxm.theoryApi.activitiesStore.createActivity(createActivitiesParam);
      }
      await vxm.theoryApi.tasksStore.fetchTaskComments({ taskId: taskId, query: query });
    }
  }

  private valueToString(value: number | Date | null): string | null {
    if (typeof value === 'number') {
      return value.toString();
    } else if (value instanceof Date) {
      return dayjs(value).format('YYYY/MM/DD');
    } else {
      return value;
    }
  }

  /** 詳細画面左枠に表示する課題属性名と値の一覧を取得 */
  private taskLeftAttributes(task: Task): TaskAttribute[] {
    /** デフォルト属性を取得 */
    let attributes: TaskAttribute[] = [];
    attributes = attributes.concat(DefaultLeftAttributes);
    attributes[0].value = task.parentTask
      ? task.parentTask.parentTaskName
      : null;
    attributes[1].value = task.milestone;
    attributes[2].value = task.eventOccurrenceVersion;
    attributes[3].value = task.completedReason;
    attributes[4].value = task.supportPhase;
    attributes[5].value = task.importance;
    attributes[6].value = task.eventOccurrenceTiming;
    attributes[7].value = task.eventSource;
    attributes[8].value = task.supportScheduledDate;
    attributes[9].value = task.releaseScheduledDate;
    attributes[10].value = task.confirmationDate;
    /** カスタム属性を取得 */
    if (this.customAttributes.length > 0) {
      this.customAttributes.forEach((attribute) => {
        /** カスタム属性を識別する数字 */
        const index = attribute.attributeNumber;
        let value: string | number | Date | null = null;
        let attributeKey: string = '';
        /** 属性の形式から、カスタム属性値を取得する */
        switch (attribute.style) {
          /** 日付形式 */
          case ATTRIBUTE_STYLE.DATE:
            attributeKey = `customAttribute${index}ValueDate`;
            value = this.task[attributeKey];
            break;
          /** 人物形式 */
          case ATTRIBUTE_STYLE.PERSON:
            attributeKey = `customAttribute${index}ValuePerson`;
            const person = this.representatives.find((member) => {
              return member.accountId === this.task[attributeKey];
            });
            if (person) {
              value = person.accountName ? person.accountName : '担当者なし';
            }
            break;
          /** テキスト形式 */
          case ATTRIBUTE_STYLE.TEXT:
            attributeKey = `customAttribute${index}ValueText`;
            value = this.task[attributeKey];
            break;
          /** 選択肢形式 */
          case ATTRIBUTE_STYLE.OPTION:
            attributeKey = `customAttribute${index}ValueOption`;
            const taskAttributeValueOption = this.taskAttributeValueOptions.find(
              (option) => {
                return (
                  option.taskAttributeValueOptionId === this.task[attributeKey]
                );
              }
            );
            value = taskAttributeValueOption
              ? taskAttributeValueOption.value
              : null;
            break;
          /** 数値形式 */
          case ATTRIBUTE_STYLE.NUMBER:
            attributeKey = `customAttribute${index}ValueNumber`;
            value = this.task[attributeKey];
            break;
          default:
            break;
        }
        /** デフォルト属性の配列に結合するためのカスタム属性 */
        const customAttribute: TaskAttribute = {
          attribute: attribute.name,
          attributeKey: attributeKey,
          attributeNumber: attribute.attributeNumber,
          style: attribute.style,
          displayStyle: attribute.displayStyle,
          displayFlag: attribute.displayFlag,
          value: value,
          customFlag: true,
        };
        attributes.push(customAttribute);
      });
    }
    return attributes;
  }

  /** 詳細画面右枠に表示する課題属性名と値の一覧を取得 */
  private taskRightAttributes(task: Task): TaskAttribute[] {
    const attributes = DefaultRightAttributes;
    attributes[0].value = task.startDate;
    attributes[1].value = task.scheduledTime;
    attributes[2].value = task.completedTime;
    attributes[3].value = task.ticketUnitPrice;
    return attributes;
  }

  /** 詳細画面左枠の各属性値の表示に対応するコンポーネントを取得 */
  private leftAttributeEditComponent(attribute: TaskAttribute) {
    /** デフォルト属性 */
    if (!attribute.customFlag) {
      if (
        attribute.attribute === AttributeName.supportScheduledDate ||
        attribute.attribute === AttributeName.releaseScheduledDate ||
        attribute.attribute === AttributeName.confirmationDate
      ) {
        return DatePickerMenu;
      } else if (attribute.attribute === AttributeName.parentTask) {
        return AddTaskList;
      } else {
        return EditableText;
      }
      /**  カスタム属性 */
    } else {
      if (attribute.style === ATTRIBUTE_STYLE.DATE) {
        return DatePickerMenu;
      } else if (attribute.style === ATTRIBUTE_STYLE.PERSON) {
        return PersonMenu;
      } else if (attribute.style === ATTRIBUTE_STYLE.TEXT) {
        return EditableText;
      } else if (attribute.style === ATTRIBUTE_STYLE.OPTION) {
        return SelectMenu;
      } else {
        return EditableText; // 仮
      }
    }
  }

  /** 詳細画面右枠の各属性値の表示に対応するコンポーネントを取得 */
  private rightAttributeEditComponent(attribute: TaskAttribute) {
    const taskAttribute = attribute.attribute;
    if (taskAttribute === AttributeName.startDate) {
      return DatePickerMenu;
    } else if (taskAttribute === AttributeName.scheduledTime) {
      return EditableTextSchedule;
    } else if (taskAttribute === AttributeName.completedTime) {
      return EditableTextPerformance;
    } else {
      return EditableText;
    }
  }

  private getTiles(attribute: TaskAttribute): Tile[] {
    const filteredTile = this.customTiles.find((tile) => {
      return tile.attributeNumber === attribute.attributeNumber;
    });
    return filteredTile ? filteredTile.customTiles : [];
  }

  /** 子課題をクリックした時に課題の状態を変更する */
  private async changeTask(childTaskId: number) {
    const query = { 'project-id': this.projectId };
    await vxm.theoryApi.tasksStore.fetchTask({ taskId: childTaskId, query: query });
    this.resetKey++;
  }

  private isDeadline(date: Date) {
    return dayjs().diff(dayjs(date)) < 0;
  }

  private openCreateCommentExplorer(): void {
    const createCommentExplorer = this.$refs.createCommentExplorer;
    createCommentExplorer.$refs.input.click();
  }

  private async getFileContent(files: (string | Blob)[] | undefined) {
    if (!files) {
      return;
    }
    this.createTaskCommentAttachmentFiles = files;
  }

  private onChangeCompletedApprovalFlag() {
    const updateTaskParam: TaskDetailParam = {
      taskId: this.task?.taskId as number,
      value: !this.task?.completedApprovalFlag as boolean,
      attributeKey: 'completedApprovalFlag',
      customFlag: false,
    };
    this.emitTaskData(updateTaskParam);
  }

  private checkIsAdministrator(): boolean {
    const member = this.representatives.find((member) => {
      return member.accountId === this.accountId;
    });
    if (member && member.role === RoleCd.administrator) {
      return true;
    } else {
      return false;
    }
  }

  private get task() {
    const response = vxm.theoryApi.tasksStore.getTask;
    if (response) {
      return response.results;
    } else return undefined;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId ? vxm.theoryApi.authStore.getCurrentProjectId : 0;
  }

  private get project() {
    const response = vxm.theoryApi.projectsStore.getProject;
    if (response) {
      return response.results;
    } else return null;
  }

  private get childTasks(): ChildTask[] {
    const task = this.task as Task;
    return task.childTasks;
  }

  private get taskComments(): TaskComment[] {
    const response = vxm.theoryApi.tasksStore.getTaskComments;
    if (response) {
      return response.results;
    } else return [];
  }

  private get taskAttributeValueOptions(): TaskAttributeValueOption[] {
    const response = vxm.theoryApi.projectsStore.getTaskAttributeValueOptions;
    if (response) {
      return response.results;
    } else return [];
  }

  private get completedApprovalSelectText() {
    if (this.task) {
      if (this.task.completedApprovalFlag) {
        return this.COMPLETED_APPROVAL_CD.select.approved;
      } else {
        return this.COMPLETED_APPROVAL_CD.select.denied;
      }
    } else return '-';
  }

  private get completedApprovalDisplayText() {
    if (this.task) {
      if (this.task.completedApprovalFlag) {
        return this.COMPLETED_APPROVAL_CD.display.approved;
      } else {
        return this.COMPLETED_APPROVAL_CD.display.denied;
      }
    } else return '-';
  }

  /**
   * 子課題リスト開閉状態の判定
   */
  private get arrowButtonRotate(): {
    'arrow-button--rotate': boolean;
  } {
    return {
      'arrow-button--rotate':
        this.isExpandChildTasks === this.EXPANTION_STATE.OPEN,
    };
  }
  // コメント入力中
  private get isWritingComment(): {
    'is-write-comment': boolean;
  } {
    return {
      'is-write-comment': this.isWriteComment,
    };
  }

  // スクロールボタンのクラスバインディング {
  private get scrollToTopUpOrDown(): {
    'scroll-to-top--up': boolean;
    'scroll-to-top--down': boolean;
  } {
    return {
      'scroll-to-top--up': this.scrollToDirection === 'up',
      'scroll-to-top--down': this.scrollToDirection === 'down',
    };
  }

  private minimization() {
    if (this.task) {
      const minimizedTask: MinimizedTask = {
        taskId: this.task.taskId,
        taskName: this.task.taskName,
      };
      const isMinimizationTask =
        vxm.theoryApi.tasksStore.getMinimizedTaskList.some((task) => {
          return task.taskId === minimizedTask.taskId;
        });
      if (!isMinimizationTask) {
        vxm.theoryApi.tasksStore.fetchMinimizedTask(minimizedTask);
      }
    }
    this.close();
  }

  @Emit('closeTaskModal')
  private close() {
    return;
  }

  @Emit('emitTaskData')
  private emitTaskData(value: TaskDetailParam): TaskDetailParam {
    return value;
  }
}
